<script lang="ts">
    import {onMount} from "svelte";
    import {SpaceUserTable} from "../../../lib/Table/SpaceUserTable";

    export let spaceUser;

    $: user = (() => {
        if (spaceUser == null) {
            return null;
        }
        const user = spaceUser.user;
        return user;
    })();

    onMount(() => {
    });


</script>

<tr class="space-authority-user-row-view">
    <td>
        { SpaceUserTable.AuthorityType.map[spaceUser.authority_type] }
    </td>
    {#if spaceUser.user != null}
        <td>
            <span class="badge">
                <!--{ UserTable.Type.map[spaceUser.user.type]  }-->
            </span>
        </td>
        <td class="company-department-job">
            <div>
                {user.company_name}
            </div>
            <div>
                {#if user.department_name != null}
                    {user.department_name}
                {/if}
            </div>
            <div>
                {#if user.job_name != null}
                    {user.job_name}
                {/if}
            </div>

        </td>
        <td>
            {user.name}
        </td>
    {:else}
        <td></td>
        <td class="email" colspan="2">
            {spaceUser.user_email}
        </td>
    {/if}

</tr>
<style lang="scss">
    .space-authority-user-row-view {
        td {
            &.type {
                .badge {

                }

            }

            &.company-department-job {
                font-size: 0.5em;
            }
        }
    }
</style>